import { Component, computed, ElementRef, inject, ViewChild, OnInit, signal } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { LayoutService } from '@layout/service/layout.service';

interface Breadcrumb {
  label: string;
  url?: string;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-breadcrumb]',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, RippleModule],
  template: `
    <nav>
      <ol class="relative z-20">
        @for (item of breadcrumbs(); track $index; let last = $last) {
          <li style="cursor: pointer;">{{ item.label }}</li>
          @if (!last) {
            <li class="layout-breadcrumb-chevron">/</li>
          }
        }
      </ol>
    </nav>
  `,
  host: {
    class: 'layout-breadcrumb flex items-center relative h-12',
  },
})
export class AppBreadcrumbComponent implements OnInit {
  @ViewChild('searchinput') searchInput!: ElementRef<HTMLElement>;

  readonly breadcrumbs = signal<Breadcrumb[]>([]);
  private readonly router = inject(Router);

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.updateBreadcrumbs();
    });
  }

  ngOnInit() {
    // Inicializar breadcrumbs inmediatamente cuando se carga el componente
    setTimeout(() => {
      this.updateBreadcrumbs();
    }, 0);
  }

  private updateBreadcrumbs() {
    const root = this.router.routerState.snapshot.root;
    const breadcrumbs: Breadcrumb[] = [];
    this.addBreadcrumb(root, [], breadcrumbs);
    this.breadcrumbs.set(breadcrumbs);
  }

  layoutService = inject(LayoutService);

  searchActive = computed(() => this.layoutService.layoutState().searchBarActive);

  private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
    const routeUrl = parentUrl.concat(route.url.map((url) => url.path));
    const breadcrumb = route.data['breadcrumb'];
    const parentBreadcrumb = route.parent && route.parent.data ? route.parent.data['breadcrumb'] : null;

    if (breadcrumb && breadcrumb !== parentBreadcrumb) {
      breadcrumbs.push({
        label: route.data['breadcrumb'],
        url: '/' + routeUrl.join('/'),
      });
    }

    if (route.firstChild) {
      this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
    }
  }

  activateSearch() {
    this.layoutService.layoutState.update((val) => ({
      ...val,
      searchBarActive: true,
    }));
    setTimeout(() => {
      this.searchInput.nativeElement?.focus();
    }, 250);
  }

  deactivateSearch() {
    this.layoutService.layoutState.update((val) => ({
      ...val,
      searchBarActive: false,
    }));
  }

  onProfileMenuButtonClick() {
    this.layoutService.layoutState.update((val) => ({
      ...val,
      rightMenuActive: true,
    }));
  }
}
